import React from 'react';

export default function PageNotFound() {
    return <div className="p-20 text-white font-mono uppercase tracking-tighter">404 - Estação não encontrada</div>;
}